import { createContext, useContext } from "react";
import { ComboboxContextProps } from "../ComboboxTypes";

export const ComboboxContext = createContext<ComboboxContextProps | null>(null);

/**
 * Hook to access the Combobox context
 * @returns The Combobox context value
 * @throws Error if used outside of a Combobox component
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useCombobox = function <Item = any>() {
  const context = useContext<ComboboxContextProps<Item> | null>(
    ComboboxContext,
  );
  if (context == null) {
    throw new Error("useCombobox must be wrapped in <Combobox />");
  }
  return context;
};
